import React from 'react'

import { REPORTING_PERIOD_OPTIONS } from '../workload.utils'

import styles from '../WorkloadDashboard.module.css'

const WorkloadPeriodControls = ({ periodType, onPeriodChange }) => (
    <div className={styles.periodControlsGroup}>
        <div
            className={styles.periodToggle}
            role="group"
            aria-label="Reporting period"
        >
            {REPORTING_PERIOD_OPTIONS.map((opt) => (
                <button
                    key={opt.value}
                    type="button"
                    className={`${styles.periodBtn} ${
                        periodType === opt.value ? styles.periodBtnActive : ''
                    }`}
                    onClick={() => onPeriodChange(opt.value)}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    </div>
)

export default WorkloadPeriodControls
